import {
	LABEL_HEIGHT_PX,
	LABEL_OFFSET_PX,
	POINT_RADIUS_PX,
	Y_AXIS_MAX,
	Y_AXIS_MIN,
} from './chartConstants';
import { IChartParams, IPointWithAlignAndSize } from '../../models';

interface ILabelIntersectionsWithBorder {
	bottomLabelIntersectsBorder: boolean;
	topLabelIntersectsBorder: boolean;
	rightLabelIntersectsBorder: boolean;
	leftLabelIntersectsBorder: boolean;
}

const defineIntersection = (pointMargin: number, labelParam: number) => {
	return pointMargin <= POINT_RADIUS_PX + LABEL_OFFSET_PX + labelParam;
};

export const getLabelIntersectionsWithChartBorders = (
	chartParams: IChartParams,
	point: IPointWithAlignAndSize,
): ILabelIntersectionsWithBorder => {
	const { maxX, minX, xRatio, yRatio } = chartParams;
	const { labelWidthPX } = point;
	const halfLabelWidth = labelWidthPX / 2;

	const bottomLabelMarginWithBottomBorderPX = (point.y - Y_AXIS_MIN) / yRatio;
	const bottomLabelMarginWithRightBorderPX = (maxX - point.x) / xRatio;
	const bottomLabelMarginWithLeftBorderPX = (point.x - minX) / xRatio;
	const topLabelMarginWithTopBorderPX = (Y_AXIS_MAX - point.y) / yRatio;
	const rightLabelMarginWithRightBorderPX = (maxX - point.x) / xRatio;
	const leftLabelMarginWithLeftBorderPX = (point.x - minX) / xRatio;
	const verticalLabelIntersectsLeftOrRightBorder =
		bottomLabelMarginWithRightBorderPX <= halfLabelWidth ||
		bottomLabelMarginWithLeftBorderPX <= halfLabelWidth;

	const isBottomIntersection =
		defineIntersection(bottomLabelMarginWithBottomBorderPX, LABEL_HEIGHT_PX) ||
		verticalLabelIntersectsLeftOrRightBorder;
	const isTopIntersection =
		defineIntersection(topLabelMarginWithTopBorderPX, LABEL_HEIGHT_PX) ||
		verticalLabelIntersectsLeftOrRightBorder;
	const isRightIntersection = defineIntersection(
		rightLabelMarginWithRightBorderPX,
		labelWidthPX,
	);
	const isLeftIntersection = defineIntersection(
		leftLabelMarginWithLeftBorderPX,
		labelWidthPX,
	);

	return {
		bottomLabelIntersectsBorder: isBottomIntersection,
		topLabelIntersectsBorder: isTopIntersection,
		rightLabelIntersectsBorder: isRightIntersection,
		leftLabelIntersectsBorder: isLeftIntersection,
	};
};
